import { Observable, of } from "rxjs";
import { WebsocketRequest, WebsocketService } from "../databases/websocket";

import { Injectable } from "@angular/core";
import { catchError } from "rxjs/operators";
import { ILogService } from "./logs/log.interface";

/* eslint-disable @typescript-eslint/naming-convention */
interface ISaveAuditEventRequestData {
    uuid?: string; // controller uuid if applicable
    entity?: string; // type of entity being acted on. i.e., user, project, clare system, service, device, etc
    object_type: string; // where the action is occurring, like sso or clarehome json-rpc or elsewhere
    operation: string;
    firebase_id: string; // firebase user id
    raw_body_content: Record<string, unknown>; // logged items
}

interface IAuditEventRequest extends WebsocketRequest {
    audit_event_data: ISaveAuditEventRequestData;
}

export enum TSLogObjectTypes {
    ssopgrest = "ssopgrest",
    verizon_thing_space = "verizon_thing_space",
    alula = "alula",
}

export enum TSLogActions {
    add = "add",
    edit = "edit",
    upsert = "upsert",
    delete = "delete",
}

@Injectable({
    providedIn: "root",
})
export class TSLoggingService implements ILogService {
    private requestType = "save_audit_event";

    constructor(private websocket: WebsocketService) {}

    // uuid, entity, object type, operation, firebase id, event data
    public logEvent(uuid?, entity?, objectType?, operation?, firebaseId?, eventData?) {
        this.saveAuditEventData({
            uuid: uuid || null,
            entity: entity || "",
            object_type: objectType || "",
            operation: operation || "",
            firebase_id: firebaseId || null,
            raw_body_content: eventData || {},
        });
    }

    public logNoSessionEventData(uuid?, entity?, objectType?, operation?, firebaseId?, eventData?) {
        this.websocket
            .makeRequest(
                {
                    request_type: this.requestType,
                    session_id: "",
                    audit_event_data: {
                        uuid: uuid || null,
                        entity: entity || "",
                        object_type: objectType || "",
                        operation: operation || "",
                        firebase_id: firebaseId || null,
                        raw_body_content: eventData || {},
                    },
                    metadata: {},
                } as IAuditEventRequest,
                false
            )
            .pipe(
                // Do not bubble up logging errors to anywhere. Make sure they are caught and end here.
                catchError(e => of(e))
            );
    }

    public saveAuditEventData(data: ISaveAuditEventRequestData): Observable<any> {
        return this.websocket.makeRequest({
            request_type: this.requestType,
            session_id: "",
            audit_event_data: data,
            metadata: {},
        } as IAuditEventRequest);
    }
}
/* eslint-enable @typescript-eslint/naming-convention */
